// ════════════════════════════════════════════════════════════════════════════
// THEME (light / dark) — shared across main menu, deck builder, and the game
// field. The actual color values live in css/style.css as CSS custom
// properties under :root[data-theme="dark"|"light"]; this file only owns the
// get/set/toggle logic and a reusable toggle-control widget. The attribute is
// also set synchronously by an inline script in index.html's <head> (before
// this file loads) so the correct theme paints on first frame.
// ════════════════════════════════════════════════════════════════════════════
const THEME_STORAGE_KEY = 'nu-theme';
const THEME_DEFAULT = 'dark';

function getTheme() {
  return document.documentElement.getAttribute('data-theme') || THEME_DEFAULT;
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  try { localStorage.setItem(THEME_STORAGE_KEY, theme); } catch {}
  document.querySelectorAll('.theme-toggle').forEach(syncThemeToggleEl);
}

function toggleTheme() {
  applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

// Reusable two-icon segmented control markup. Callers inject this HTML
// wherever a toggle should appear, then call wireThemeToggle() once per
// injected copy so its buttons become interactive.
function renderThemeToggleHTML() {
  return `
    <div class="theme-toggle">
      <button type="button" class="theme-toggle-btn" data-theme-choice="dark" title="Dark theme">
        <span class="material-symbols-outlined">dark_mode</span>
      </button>
      <button type="button" class="theme-toggle-btn" data-theme-choice="light" title="Light theme">
        <span class="material-symbols-outlined">light_mode</span>
      </button>
    </div>
  `;
}

function syncThemeToggleEl(el) {
  const current = getTheme();
  el.querySelectorAll('.theme-toggle-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.themeChoice === current);
  });
}

function wireThemeToggle(containerEl) {
  const toggleEl = containerEl.classList?.contains('theme-toggle')
    ? containerEl
    : containerEl.querySelector('.theme-toggle');
  if (!toggleEl) return;
  syncThemeToggleEl(toggleEl);
  toggleEl.querySelectorAll('.theme-toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => applyTheme(btn.dataset.themeChoice));
  });
}
